module.exports = __webpack_public_path__ + "b21342e9f2c04f4f648d4576b5d16456.fbx";